export default "__VITE_ASSET__2b9c509b__"